export default "__VITE_ASSET__DPK3aMRW__"